/* eslint-disable no-redeclare */
import { z } from 'zod';

export const JourneyAlias = z.enum([
  'HEALTH_DEFAULT',
  'MEDICARE_ADVANTAGE',
  'MEDICARE_GENERIC',
  'MEDICARE_SUPPLEMENT',
  'LIFE_DEFAULT',
  '114', // Testing life insurance
  '112', // MP-2416 Health - remove tobacco plate
  '117', // MP-2927 Medicare Advantage - Call oriented journey
  '119', // MP-3314 Health - Call oriented journey
  '121', // MP-3359 Medicare Advantage - Call oriented journey
  '129', // MP-3478 Medicare Advantage - Call oriented journey V3
]);
export type JourneyAlias = z.infer<typeof JourneyAlias>;
